import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4fc7f832"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "booking-setting__wrapper",
  class: "main-content-wrapper"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "main-content-page-title" }, "基本設定", -1))
const _hoisted_3 = { class: "booking-setting__content pt-2" }
const _hoisted_4 = ["onSubmit"]
const _hoisted_5 = { class: "flex" }
const _hoisted_6 = { class: "text-field mr-0 flex flex-column align-items-start" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label-input" }, "予約受付の可能日数", -1))
const _hoisted_8 = { class: "dropdown mb-3" }
const _hoisted_9 = { class: "flex align-items-center" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "label-input ml-2" }, "日先まで", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label-input" }, "予約受付締切", -1))
const _hoisted_12 = { class: "dropdown mb-3" }
const _hoisted_13 = { class: "flex align-items-center" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "label-input ml-2" }, "分前まで", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label-input" }, "予約受付時間間隔", -1))
const _hoisted_16 = { class: "dropdown mb-3" }
const _hoisted_17 = { class: "flex align-items-center" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "label-input ml-2" }, "分", -1))
const _hoisted_19 = { class: "flex" }
const _hoisted_20 = { class: "message-content w-full" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label-input" }, "電話予約受付開始", -1))
const _hoisted_22 = { class: "flex align-items-center mt-2 mb-2" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label-input ml-2 mr-3" }, "日", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label-input ml-2 mr-3" }, "時", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label-input ml-2 mr-3" }, "分", -1))
const _hoisted_26 = { class: "flex flex-column mt-3 mb-2" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label-input mb-3" }, "指名予約", -1))
const _hoisted_28 = { class: "flex flex-wrap gap-3" }
const _hoisted_29 = { class: "flex align-items-center radio-wrapper__custom" }
const _hoisted_30 = {
  key: 0,
  class: "icon-lms icon-lms_rad-chosen radio-icon"
}
const _hoisted_31 = {
  key: 1,
  class: "icon-lms icon-lms_radio radio-icon"
}
const _hoisted_32 = { class: "flex align-items-center radio-wrapper__custom" }
const _hoisted_33 = {
  key: 0,
  class: "icon-lms icon-lms_rad-chosen radio-icon"
}
const _hoisted_34 = {
  key: 1,
  class: "icon-lms icon-lms_radio radio-icon"
}
const _hoisted_35 = {
  key: 0,
  class: "flex flex-column mt-3 mb-2"
}
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label-input mb-3" }, "指名予約ボタンの選択", -1))
const _hoisted_37 = { class: "flex flex-wrap gap-3" }
const _hoisted_38 = { class: "flex align-items-center radio-wrapper__custom" }
const _hoisted_39 = {
  key: 0,
  class: "icon-lms icon-lms_rad-chosen radio-icon"
}
const _hoisted_40 = {
  key: 1,
  class: "icon-lms icon-lms_radio radio-icon"
}
const _hoisted_41 = { class: "flex align-items-center radio-wrapper__custom" }
const _hoisted_42 = {
  key: 0,
  class: "icon-lms icon-lms_rad-chosen radio-icon"
}
const _hoisted_43 = {
  key: 1,
  class: "icon-lms icon-lms_radio radio-icon"
}
const _hoisted_44 = { class: "flex flex-column mt-3 mb-2" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label-input mb-3" }, "オプション選択", -1))
const _hoisted_46 = { class: "flex flex-wrap gap-3" }
const _hoisted_47 = { class: "flex align-items-center radio-wrapper__custom" }
const _hoisted_48 = {
  key: 0,
  class: "icon-lms icon-lms_rad-chosen radio-icon"
}
const _hoisted_49 = {
  key: 1,
  class: "icon-lms icon-lms_radio radio-icon"
}
const _hoisted_50 = { class: "flex align-items-center radio-wrapper__custom" }
const _hoisted_51 = {
  key: 0,
  class: "icon-lms icon-lms_rad-chosen radio-icon"
}
const _hoisted_52 = {
  key: 1,
  class: "icon-lms icon-lms_radio radio-icon"
}
const _hoisted_53 = { class: "flex flex-column mt-3 mb-2" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label-input mb-3" }, "予約自動振り分け", -1))
const _hoisted_55 = { class: "flex flex-wrap gap-3" }
const _hoisted_56 = ["for"]
const _hoisted_57 = { class: "flex" }
const _hoisted_58 = { class: "message-content w-8" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label-input" }, "キャンセル受付締切", -1))
const _hoisted_60 = { class: "flex mt-2" }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label-input ml-2 mr-3 pt-2 mt-1" }, "日", -1))
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label-input ml-2 mr-3 pt-2 mt-1" }, "時", -1))
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label-input ml-2 mr-3 pt-2 mt-1" }, "分", -1))
const _hoisted_64 = { class: "flex flex-column mt-3 mb-2" }
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label-input mb-2" }, "自由予約", -1))
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-xs text-red-600 mt-0 mb-3" }, "※ 設定変更後は、もう一度ログインしてください。", -1))
const _hoisted_67 = { class: "flex flex-wrap gap-3" }
const _hoisted_68 = { class: "flex align-items-center radio-wrapper__custom" }
const _hoisted_69 = { class: "flex align-items-center radio-wrapper__custom" }
const _hoisted_70 = { class: "grid my-4 w-full" }
const _hoisted_71 = { class: "col-5 col-offset-3" }

import { notityErrorMsg, notifySuccessMsg } from "@/clinic/utils/notify-utils";
import { ref, reactive, inject, onBeforeMount } from "vue";
import { get, set } from "@vueuse/core";
import { useToast } from "primevue/usetoast";
import BookingSettingService from "@/clinic/services/booking-setting";
import Dropdown from "primevue/dropdown";
import RadioButton from "primevue/radiobutton";
import Toast from "primevue/toast";


export default /*#__PURE__*/_defineComponent({
  __name: 'BookingSetting',
  setup(__props) {

const toast = useToast();
const clinicId = ref(0);
const handleOptions = options => {
  return options.map(option => {
    return {
      name: option.toString(),
      value: option,
    };
  });
};

const durationOptions = [10, 15, 20, 30, 60];
const defaultOptionDays = handleOptions(durationOptions);
const bookingDayOptions = [7, 14, 20, 30, 60, 90];
const autoStaffDistributionOptions = [
  { label: "オン", value: 1 },
  { label: "オフ", value: 0 },
];

const maxBookingDayOptions = ref(handleOptions(bookingDayOptions));
const minBookingDayOptions = ref([{ name: "0", value: 0 }, ...defaultOptionDays]);
const bookingDurationOptions = ref(defaultOptionDays);
const form = reactive<any>({
  data: {},
});

const submit = async () => {
  form.data.cancel_time =
    form.data.cancel_time_days * 1440 + form.data.cancel_time_hours * 60 + parseInt(form.data.cancel_time_minutes);
  form.data.can_booking_before_call =
    form.data.can_booking_before_call_days * 1440 +
    form.data.can_booking_before_call_hours * 60 +
    parseInt(form.data.can_booking_before_call_minutes);
  await BookingSettingService.updateBookingSetting(
    {
      clinic_booking_setting: {
        ...form.data,
      },
    },
    get(clinicId.value),
    () => notifySuccessMsg(toast, "保存が完了しました"),
    (error: any) => notityErrorMsg(toast, error.join(", "))
  );
};

onBeforeMount(async () => {
  await set(clinicId, await inject("clinicId"));
  await BookingSettingService.getBookingSetting(
    get(clinicId.value),
    (response: any) => {
      const formData = { ...response };
      formData.option = formData.option === "no_nominate" ? 1 : 0;
      form.data = formData;
      form.data.cancel_time_days = Math.floor(formData.cancel_time / 1440);
      form.data.cancel_time_hours = Math.floor((formData.cancel_time % 1440) / 60);
      form.data.cancel_time_minutes = Math.floor((formData.cancel_time % 1440) % 60);
      form.data.can_booking_before_call_days = Math.floor(formData.can_booking_before_call / 1440);
      form.data.can_booking_before_call_hours = Math.floor((formData.can_booking_before_call % 1440) / 60);
      form.data.can_booking_before_call_minutes = Math.floor((formData.can_booking_before_call % 1440) % 60);
    },
    (error: any) => notityErrorMsg(toast, "何かが間違っています。後でもう一度試してください")
  );
});

return (_ctx: any,_cache: any) => {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("form", {
          onSubmit: _withModifiers(submit, ["prevent"])
        }, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_unref(Dropdown), {
                    modelValue: form.data.max_booking_days,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.data.max_booking_days) = $event)),
                    modelModifiers: { number: true },
                    optionLabel: "name",
                    optionValue: "value",
                    placeholder: "90日前",
                    class: "w-full md:w-20rem input-custom",
                    options: maxBookingDayOptions.value
                  }, null, 8, ["modelValue", "options"]),
                  _hoisted_10
                ])
              ]),
              _hoisted_11,
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createVNode(_unref(Dropdown), {
                    modelValue: form.data.min_booking_minutes,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.data.min_booking_minutes) = $event)),
                    modelModifiers: { number: true },
                    optionLabel: "name",
                    optionValue: "value",
                    placeholder: "直前",
                    class: "w-full md:w-20rem input-custom",
                    options: minBookingDayOptions.value
                  }, null, 8, ["modelValue", "options"]),
                  _hoisted_14
                ])
              ]),
              _hoisted_15,
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _createVNode(_unref(Dropdown), {
                    modelValue: form.data.booking_duration,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.data.booking_duration) = $event)),
                    modelModifiers: { number: true },
                    optionLabel: "name",
                    optionValue: "value",
                    placeholder: "60",
                    class: "w-full md:w-20rem input-custom",
                    options: bookingDurationOptions.value
                  }, null, 8, ["modelValue", "options"]),
                  _hoisted_18
                ])
              ]),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _hoisted_21,
                  _createElementVNode("div", _hoisted_22, [
                    _createVNode(_component_InputText, {
                      modelValue: form.data.can_booking_before_call_days,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.data.can_booking_before_call_days) = $event)),
                      "aria-describedby": "time-unit-help",
                      type: "number",
                      size: "large",
                      min: 0,
                      max: form.data.max_booking_days,
                      name: "can_booking_before_call",
                      class: "w-full"
                    }, null, 8, ["modelValue", "max"]),
                    _hoisted_23,
                    _createVNode(_component_InputText, {
                      type: "number",
                      size: "large",
                      min: 0,
                      max: 23,
                      name: "position_number",
                      class: "w-full",
                      modelValue: form.data.can_booking_before_call_hours,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.data.can_booking_before_call_hours) = $event))
                    }, null, 8, ["modelValue"]),
                    _hoisted_24,
                    _createVNode(_component_InputText, {
                      type: "number",
                      size: "large",
                      min: 0,
                      max: 59,
                      name: "position_number",
                      class: "w-full",
                      modelValue: form.data.can_booking_before_call_minutes,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.data.can_booking_before_call_minutes) = $event))
                    }, null, 8, ["modelValue"]),
                    _hoisted_25
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_26, [
                _hoisted_27,
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("div", _hoisted_29, [
                    _createVNode(_unref(RadioButton), {
                      modelValue: form.data.option,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((form.data.option) = $event)),
                      modelModifiers: { number: true },
                      inputId: "option_accept",
                      name: "option",
                      value: "0"
                    }, null, 8, ["modelValue"]),
                    _createElementVNode("label", {
                      for: "option_accept",
                      class: _normalizeClass(["flex algin-items-center", { 'text-orange': Number(form.data.option) === 0 }])
                    }, [
                      (Number(form.data.option) === 0)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_30))
                        : (_openBlock(), _createElementBlock("span", _hoisted_31)),
                      _createTextVNode(" 受け付ける ")
                    ], 2)
                  ]),
                  _createElementVNode("div", _hoisted_32, [
                    _createVNode(_unref(RadioButton), {
                      modelValue: form.data.option,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((form.data.option) = $event)),
                      modelModifiers: { number: true },
                      inputId: "option_not_accept",
                      name: "option",
                      value: "1"
                    }, null, 8, ["modelValue"]),
                    _createElementVNode("label", {
                      for: "option_not_accept",
                      class: _normalizeClass(["flex algin-items-center", { 'text-orange': Number(form.data.option) === 1 }])
                    }, [
                      (Number(form.data.option) === 1)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_33))
                        : (_openBlock(), _createElementBlock("span", _hoisted_34)),
                      _createTextVNode(" 受け付けない ")
                    ], 2)
                  ])
                ])
              ]),
              (Number(form.data.option) === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                    _hoisted_36,
                    _createElementVNode("div", _hoisted_37, [
                      _createElementVNode("div", _hoisted_38, [
                        _createVNode(_unref(RadioButton), {
                          modelValue: form.data.show_button_without_staff,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((form.data.show_button_without_staff) = $event)),
                          inputId: "show_button_without_staff",
                          name: "show_button_without_staff",
                          value: "1"
                        }, null, 8, ["modelValue"]),
                        _createElementVNode("label", {
                          for: "show_button_without_staff",
                          class: _normalizeClass(["flex algin-items-center", { 'text-orange': Number(form.data.show_button_without_staff) === 1 }])
                        }, [
                          (Number(form.data.show_button_without_staff) === 1)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_39))
                            : (_openBlock(), _createElementBlock("span", _hoisted_40)),
                          _createTextVNode(" 表示する ")
                        ], 2)
                      ]),
                      _createElementVNode("div", _hoisted_41, [
                        _createVNode(_unref(RadioButton), {
                          modelValue: form.data.show_button_without_staff,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((form.data.show_button_without_staff) = $event)),
                          inputId: "hide_button_without_staff",
                          name: "show_button_without_staff",
                          value: "0"
                        }, null, 8, ["modelValue"]),
                        _createElementVNode("label", {
                          for: "hide_button_without_staff",
                          class: _normalizeClass(["flex algin-items-center", { 'text-orange': Number(form.data.show_button_without_staff) === 0 }])
                        }, [
                          (Number(form.data.show_button_without_staff) === 0)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_42))
                            : (_openBlock(), _createElementBlock("span", _hoisted_43)),
                          _createTextVNode(" 表示しない ")
                        ], 2)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_44, [
                _hoisted_45,
                _createElementVNode("div", _hoisted_46, [
                  _createElementVNode("div", _hoisted_47, [
                    _createVNode(_unref(RadioButton), {
                      modelValue: form.data.option_require,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((form.data.option_require) = $event)),
                      modelModifiers: { number: true },
                      inputId: "option_require",
                      name: "option_require",
                      value: "1"
                    }, null, 8, ["modelValue"]),
                    _createElementVNode("label", {
                      for: "option_require",
                      class: _normalizeClass(["flex algin-items-center", { 'text-orange': Number(form.data.option_require) === 1 }])
                    }, [
                      (Number(form.data.option_require) === 1)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_48))
                        : (_openBlock(), _createElementBlock("span", _hoisted_49)),
                      _createTextVNode(" 必須 ")
                    ], 2)
                  ]),
                  _createElementVNode("div", _hoisted_50, [
                    _createVNode(_unref(RadioButton), {
                      modelValue: form.data.option_require,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((form.data.option_require) = $event)),
                      modelModifiers: { number: true },
                      inputId: "option_not_require",
                      name: "option_require",
                      value: "0"
                    }, null, 8, ["modelValue"]),
                    _createElementVNode("label", {
                      for: "option_not_require",
                      class: _normalizeClass(["flex algin-items-center", { 'text-orange': Number(form.data.option_require) === 0 }])
                    }, [
                      (Number(form.data.option_require) === 0)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_51))
                        : (_openBlock(), _createElementBlock("span", _hoisted_52)),
                      _createTextVNode(" 任意 ")
                    ], 2)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_53, [
                _hoisted_54,
                _createElementVNode("div", _hoisted_55, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(autoStaffDistributionOptions, (option) => {
                    return _createElementVNode("div", {
                      class: "flex align-items-center radio-wrapper__custom",
                      key: option.value
                    }, [
                      _createVNode(_unref(RadioButton), {
                        modelValue: form.data.auto_staff_distribution,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((form.data.auto_staff_distribution) = $event)),
                        modelModifiers: { number: true },
                        inputId: `auto_staff_distribution_${option.value}`,
                        name: "auto_staff_distribution",
                        value: option.value
                      }, null, 8, ["modelValue", "inputId", "value"]),
                      _createElementVNode("label", {
                        for: `auto_staff_distribution_${option.value}`,
                        class: _normalizeClass(["flex algin-items-center", { 'text-orange': form.data.auto_staff_distribution == option.value }])
                      }, [
                        _createElementVNode("span", {
                          class: _normalizeClass([
                        'icon-lms',
                        form.data.auto_staff_distribution == option.value ? 'icon-lms_rad-chosen' : 'icon-lms_radio',
                        'radio-icon',
                      ])
                        }, null, 2),
                        _createTextVNode(" " + _toDisplayString(option.label), 1)
                      ], 10, _hoisted_56)
                    ])
                  }), 64))
                ])
              ]),
              _createElementVNode("div", _hoisted_57, [
                _createElementVNode("div", _hoisted_58, [
                  _hoisted_59,
                  _createElementVNode("div", _hoisted_60, [
                    _createVNode(_component_InputText, {
                      type: "number",
                      size: "large",
                      min: 0,
                      name: "position_number",
                      class: "w-full",
                      modelValue: form.data.cancel_time_days,
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((form.data.cancel_time_days) = $event))
                    }, null, 8, ["modelValue"]),
                    _hoisted_61,
                    _createVNode(_component_InputText, {
                      type: "number",
                      size: "large",
                      min: 0,
                      max: 23,
                      name: "position_number",
                      class: "w-full",
                      modelValue: form.data.cancel_time_hours,
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((form.data.cancel_time_hours) = $event))
                    }, null, 8, ["modelValue"]),
                    _hoisted_62,
                    _createVNode(_component_InputText, {
                      type: "number",
                      size: "large",
                      min: 0,
                      max: 59,
                      name: "position_number",
                      class: "w-full",
                      modelValue: form.data.cancel_time_minutes,
                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((form.data.cancel_time_minutes) = $event))
                    }, null, 8, ["modelValue"]),
                    _hoisted_63
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_64, [
                _hoisted_65,
                _hoisted_66,
                _createElementVNode("div", _hoisted_67, [
                  _createElementVNode("div", _hoisted_68, [
                    _createVNode(_unref(RadioButton), {
                      modelValue: form.data.show_free_space,
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((form.data.show_free_space) = $event)),
                      modelModifiers: { number: true },
                      inputId: "show_free_space_on",
                      name: "show_free_space",
                      value: 1
                    }, null, 8, ["modelValue"]),
                    _createElementVNode("label", {
                      for: "show_free_space_on",
                      class: _normalizeClass(["flex algin-items-center", { 'text-orange': Number(form.data.show_free_space) === 1 }])
                    }, [
                      _createElementVNode("span", {
                        class: _normalizeClass([
                        'icon-lms',
                        Number(form.data.show_free_space) === 1 ? 'icon-lms_rad-chosen' : 'icon-lms_radio',
                        'radio-icon',
                      ])
                      }, null, 2),
                      _createTextVNode(" 表示する ")
                    ], 2)
                  ]),
                  _createElementVNode("div", _hoisted_69, [
                    _createVNode(_unref(RadioButton), {
                      modelValue: form.data.show_free_space,
                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((form.data.show_free_space) = $event)),
                      modelModifiers: { number: true },
                      inputId: "show_free_space_off",
                      name: "show_free_space",
                      value: 0
                    }, null, 8, ["modelValue"]),
                    _createElementVNode("label", {
                      for: "show_free_space_off",
                      class: _normalizeClass(["flex algin-items-center", { 'text-orange': Number(form.data.show_free_space) === 0 }])
                    }, [
                      _createElementVNode("span", {
                        class: _normalizeClass([
                        'icon-lms',
                        Number(form.data.show_free_space) === 0 ? 'icon-lms_rad-chosen' : 'icon-lms_radio',
                        'radio-icon',
                      ])
                      }, null, 2),
                      _createTextVNode(" 表示しない ")
                    ], 2)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_70, [
                _createElementVNode("div", _hoisted_71, [
                  _createVNode(_component_Button, {
                    label: "保存する",
                    type: "submit"
                  })
                ])
              ])
            ])
          ])
        ], 40, _hoisted_4)
      ])
    ]),
    _createVNode(_unref(Toast), { position: "top-center" })
  ], 64))
}
}

})